import {
  AgreementToSign,
  AgreementsProps,
} from "@src/app/onboardingStripe/components/AgreementToSign";
import { useGetAgreements } from "@src/appV2/Agreements/api/useGetAgreements";
import { AgreementKind } from "@src/appV2/Agreements/types";
import { getNewestSignedAgreementFromResponse } from "@src/appV2/Agreements/utils/getNewestSignedAgreementFromResponse";
import { PdfViewerProvider } from "@src/appV2/PdfViewer/context";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

type AgreementContainerProps = Pick<
  AgreementsProps,
  "isLoading" | "onAcceptAgreement" | "disableBackButton"
>;

/**
 *
 * @deprecated. We are working on deprecating this page. Once we have have new signing up flow, this page will be removed.
 *
 * New roles page: src/appV2/redesign/Onboarding/OnboardingFlowContainer/ICAgreementStep/ICAgreementStep.tsx
 * See: https://linear.app/clipboardhealth/issue/ACT-2933/update-sign-new-agreement-flow-to-use-updated-ic-agreement-design
 */
export function AgreementContainer(props: AgreementContainerProps) {
  const worker = useDefinedWorker();

  const workerId = worker.userId;

  const {
    data: agreements,
    isLoading: isLoadingAgreements,
    isError: isErrorAgreements,
    isSuccess: isSuccessAgreements,
  } = useGetAgreements(
    {
      workerId,
      kind: [AgreementKind.INDEPENDENT_CONTRACTOR],
    },
    { refetchOnWindowFocus: false }
  );

  const agreementToSign = isSuccessAgreements
    ? getNewestSignedAgreementFromResponse(agreements)
    : undefined;

  const pdfUrl = agreementToSign?.attributes.downloadUrl;

  return (
    <PdfViewerProvider fileName="clipboard_health_contract.pdf" pdfUrl={pdfUrl}>
      <AgreementToSign
        isLoading={props.isLoading}
        onAcceptAgreement={props.onAcceptAgreement}
        disableBackButton={props.disableBackButton}
        isLoadingAgreements={isLoadingAgreements}
        isErrorAgreements={isErrorAgreements}
        isSuccessAgreements={isSuccessAgreements}
        agreementToSign={agreementToSign}
      />
    </PdfViewerProvider>
  );
}
